__turbopack_context__.v({
  "container": "index-module__g6jADa__container",
  "fadeInItems": "index-module__g6jADa__fadeInItems",
  "location": "index-module__g6jADa__location",
  "locations": "index-module__g6jADa__locations",
  "logo": "index-module__g6jADa__logo",
  "noItems": "index-module__g6jADa__noItems",
  "spacing--lg": "index-module__g6jADa__spacing--lg",
  "spacing--md": "index-module__g6jADa__spacing--md",
  "spacing--sm": "index-module__g6jADa__spacing--sm",
  "spacing--xl": "index-module__g6jADa__spacing--xl",
  "spacing--xs": "index-module__g6jADa__spacing--xs",
  "spacing--xxl": "index-module__g6jADa__spacing--xxl",
  "spacing--xxs": "index-module__g6jADa__spacing--xxs",
  "spacing--xxxl": "index-module__g6jADa__spacing--xxxl",
  "spacing--xxxs": "index-module__g6jADa__spacing--xxxs",
});
